import { data } from '../../svg/Help/data';
import { makeIcon } from '../makeIcon';

export const Help = makeIcon(data, 'help', 'Help');

export default Help;
